// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Photos-pageContent-KLFfF {
	max-width: var(--max-content-width);
	position: relative;
	display: block;
	margin: 0px auto;
	padding: 0px;
}

.Photos-titleText-Sp592 {
	font-size: 30px;
	margin: 0px;
	color: var(--primary-foreground);
	font-weight: bold;
	word-break: break-word;
}

.Photos-titleText-Sp592:hover,
.Photos-titleText-Sp592:active,
.Photos-titleText-Sp592:focus {
	color: var(--primary-foreground);
	text-decoration: none;
}

.Photos-sectionTitleText-Nzqjt {
	font-size: 20px;
	margin: 0px;
	margin-bottom: 16px;
	font-weight: 600;
}

.Photos-sectionTitleContent-p2mWT {
	font-size: 16px;
	color: var(--secondary-foreground);
}

.Photos-sectionCaptionLink-zldFy {
	font-size: 16px;
	color: var(--secondary-foreground);
}

a {
	cursor: pointer;
}

a:focus {
	outline: none;
}

.Photos-textMuted-AIHu3,
.Photos-textMuted-AIHu3:hover,
.Photos-textMuted-AIHu3:focus,
.Photos-textMuted-AIHu3:hover:focus {
	color: var(--secondary-foreground);
	text-decoration: none;
	font-size: inherit;
}

.Photos-text-cyyMI {
	color: inherit;
	font-size: inherit;
	font-weight: normal;
}

.Photos-textLine-MAvh6 {
	text-decoration: line-through;
}

.Photos-textCenter-V7V68 {
	text-align: center;
}

.Photos-textError-yASZr {
	color: var(--alert-color);
}

.Photos-horizontalLineThrough-T2NRr {
	position: relative;
	display: block;
}

.Photos-pageContent-KLFfF .Photos-horizontalLineThrough-T2NRr:last-child {
	border-bottom: 0px;
}

.Photos-space1-hqCU1 {
	margin-bottom: 6px;
}

.Photos-space2-HFGZk {
	margin-bottom: 12px;
}

.Photos-space3-ReN5d {
	margin-bottom: 18px;
}

.Photos-space4-Rrdtl {
	margin-bottom: 24px;
}

.Photos-space5-Q_vEk {
	margin-bottom: 48px;
}

.Photos-spaceTop1-T_ZEY {
	margin-top: 6px;
}

.Photos-spaceTop2-PpwiX {
	margin-top: 12px;
}

.Photos-spaceTop3-xNMB0 {
	margin-top: 18px;
}

.Photos-spaceTop4-UERTY {
	margin-top: 24px;
}

.Photos-spaceTop5-FR1mh {
	margin-top: 48px;
}

.Photos-padding1-jvtJw {
	padding-bottom: 6px;
}

.Photos-padding2-H_WeB {
	padding-bottom: 12px;
}

.Photos-padding3-YSYNm {
	padding-bottom: 18px;
}

.Photos-padding4-kipCL {
	padding-bottom: 24px;
}

.Photos-padding5-ulE5u {
	padding-bottom: 48px;
}

.Photos-paddingTop1-WdVxj {
	padding-top: 6px;
}

.Photos-paddingTop2-rsxhE {
	padding-top: 12px;
}

.Photos-paddingTop3-R5wAz {
	padding-top: 18px;
}

.Photos-paddingTop4-RgWhL {
	padding-top: 24px;
}

.Photos-paddingTop5-SUVMl {
	padding-top: 48px;
}

.Photos-noMargin-ZIOOW {
	margin: 0px;
}

.Photos-noPadding-youN1 {
	padding: 0px;
}

.Photos-noBorder-a2u6n {
	border: 0px none !important;
}

.Photos-btn-HSSaM {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: var(--primary-color);
	color: var(--white-color);
	font-weight: bold;
	font-size: 16px;
	outline: none !important;
}

.Photos-btnBlock-gtsQd {
	width: 100%;
	position: relative;
	white-space: normal;
	display: block;
}

.Photos-btn-HSSaM:hover,
.Photos-btn-HSSaM:focus,
.Photos-btn-HSSaM:hover:focus {
	background: transparent;
	color: var(--primary-foreground);
}

.Photos-formControlSelect-HLoGf {
	margin-bottom: 8px;
}

.Photos-splitList-kr8R0 {
	display: inline-block;
	width: 50%;
	font-size: 16px;
	padding-right: 8px;
}

.Photos-displayTable-Yhq1V {
	display: table;
	width: 100%;
}

.Photos-displayTableRow-SGJcq {
	display: table-row;
	width: 100%;
}

.Photos-displayTableCell-V53ua {
	display: table-cell;
	width: 100%;
}

.Photos-displayTableCellIcon-QI__b {
	display: table-cell;
	vertical-align: top;
}

.Photos-textMutedNew-Gd6Ki {
	font-size: 16px;
	font-weight: 700;
	vertical-align: middle;
	word-break: break-word;
	line-height: 26px;
}

.Photos-tableMarginTop-UN_7w {
	margin-top: 16px;
}

.Photos-calendarTableCell-uaNnj {
	display: inline-block;
}

.Photos-vrAlignTop-x3ekh {
	vertical-align: top;
}

.Photos-currenyMarginR-qWKgF {
	margin-right: 6px;
}

.Photos-sectionLink-agwzI {
	border: 1px solid var(--secondary-bg);
	padding: 10px;
	border-radius: 4px;
}

.Photos-listingFontSize-MeHPE {
	font-size: 16px !important;
}

.Photos-vrAlignBottom-OeJ3F {
	vertical-align: bottom;
}

.Photos-introTextPadding-Zo9M5 {
	padding-left: 8px;
}

.Photos-showHideBtn-UnCR4 {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px !important;
	border: 0px !important;
	text-decoration: underline;
}

.Photos-showHideBtn-UnCR4.Photos-focus-h2kNH,
.Photos-showHideBtn-UnCR4:focus,
.Photos-showHideBtn-UnCR4:active,
.Photos-showHideBtn-UnCR4:active:focus,
.Photos-showHideBtn-UnCR4:focus,
.Photos-showHideBtn-UnCR4:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: 16px;
	border: 0px !important;
}

.Photos-showHideMargin-AmNGd {
	margin-bottom: 10px !important;
}

.Photos-listingIntroWidth-Tryrb {
	width: 65%;
}

.Photos-showHidePadding-SWn5C {
	padding-bottom: 10px !important;
}

.Photos-vtrTop-A53SQ {
	vertical-align: top;
}

.Photos-listingLine-imeyR {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Photos-listingLineTwo-kr70W {
	margin: 15px 0 30px;
}

@media screen and (max-width: 767px) {
	.Photos-titleText-Sp592 {
		font-weight: 700;
		font-size: 26px;
		word-break: break-word;
	}

	.Photos-splitList-kr8R0 {
		display: inline-block;
		width: 100% !important;
	}

	.Photos-listingIntroWidth-Tryrb {
		width: 100% !important;
	}

	.Photos-responsiveListIngIntro-qHwlu {
		display: inline-block !important;
	}
}

.Photos-bannerContainer-V087T {
	height: 500px;
	position: relative;
	width: 100%;
	-webkit-transition: height .2s;
	transition: height .2s;
	cursor: pointer;
	border-radius: 15px;
}

.Photos-bannerImage-H4Sw8 {
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 50% 50%;
	min-height: 500px;
}

.Photos-viewPhotosBtn-dOlNh {
	bottom: 20px;
	right: 20px;
	position: absolute;
	display: inline-block;
	background: var(--background-primary) !important;
	color: var(--primary-foreground) !important;
	font-size: 16px !important;
	font-weight: bold !important;
	border-radius: 8px !important;
	font-weight: normal;
	cursor: pointer !important;
	width: -webkit-max-content;
	width: -moz-max-content;
	width: max-content;
	border-color: transparent !important;
}

.Photos-bannerImage-H4Sw8:hover {
	cursor: pointer;
}

.Photos-vtrBottom-kUXhT {
	vertical-align: bottom;
}

.Photos-vtrMiddle-ee0zx {
	vertical-align: middle;
}

.Photos-saveButtonPosition-sn0hY {
	position: absolute;
	top: 20px;
	right: 20px;
}

.Photos-displayInline-y7EPc {
	display: inline-block;
	margin-left: 25px;
}

.Photos-positionRelative-m6JT0 {
	position: relative;
}

@media screen and (max-height: 1200px) {
	.Photos-saveButtonPosition-sn0hY {
		right: 0px;
	}
}

@media screen and (min-height: 700px) {

	/* .bannerContainer {
		height: 552px;
	} */
	.Photos-leftBanner-JxpJ8 {
		height: 552px;
	}
}

@media screen and (min-height: 850px) {

	/* .bannerContainer {
		height: 545px;
	} */
	.Photos-leftBanner-JxpJ8 {
		height: 850px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/common.css","webpack://./src/components/ViewListing/Photos/Photos.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;;CAGC,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;;;;CAIC,kCAAkC;CAClC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,mCAAmC;CACnC,gCAAgC;CAChC,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;;CAGC,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;CACvB,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;;AAEA;;;;;;CAMC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;EACrB,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gCAAgC;CACjC;AACD;;ACjWA;CACC,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,8BAAsB;CAAtB,sBAAsB;CACtB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,qBAAqB;CACrB,gDAAgD;CAChD,2CAA2C;CAC3C,0BAA0B;CAC1B,4BAA4B;CAC5B,6BAA6B;CAC7B,mBAAmB;CACnB,0BAA0B;CAC1B,0BAAkB;CAAlB,uBAAkB;CAAlB,kBAAkB;CAClB,oCAAoC;AACrC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;;CAEC;;IAEG;CACH;EACC,aAAa;CACd;AACD;;AAEA;;CAEC;;IAEG;CACH;EACC,aAAa;CACd;AACD","sourcesContent":[".pageContent {\n\tmax-width: var(--max-content-width);\n\tposition: relative;\n\tdisplay: block;\n\tmargin: 0px auto;\n\tpadding: 0px;\n}\n\n.titleText {\n\tfont-size: 30px;\n\tmargin: 0px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: bold;\n\tword-break: break-word;\n}\n\n.titleText:hover,\n.titleText:active,\n.titleText:focus {\n\tcolor: var(--primary-foreground);\n\ttext-decoration: none;\n}\n\n.sectionTitleText {\n\tfont-size: 20px;\n\tmargin: 0px;\n\tmargin-bottom: 16px;\n\tfont-weight: 600;\n}\n\n.sectionTitleContent {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n.sectionCaptionLink {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\na {\n\tcursor: pointer;\n}\n\na:focus {\n\toutline: none;\n}\n\n.textMuted,\n.textMuted:hover,\n.textMuted:focus,\n.textMuted:hover:focus {\n\tcolor: var(--secondary-foreground);\n\ttext-decoration: none;\n\tfont-size: inherit;\n}\n\n.text {\n\tcolor: inherit;\n\tfont-size: inherit;\n\tfont-weight: normal;\n}\n\n.textLine {\n\ttext-decoration: line-through;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.textError {\n\tcolor: var(--alert-color);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.pageContent .horizontalLineThrough:last-child {\n\tborder-bottom: 0px;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.space5 {\n\tmargin-bottom: 48px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.spaceTop5 {\n\tmargin-top: 48px;\n}\n\n.padding1 {\n\tpadding-bottom: 6px;\n}\n\n.padding2 {\n\tpadding-bottom: 12px;\n}\n\n.padding3 {\n\tpadding-bottom: 18px;\n}\n\n.padding4 {\n\tpadding-bottom: 24px;\n}\n\n.padding5 {\n\tpadding-bottom: 48px;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px;\n}\n\n.paddingTop5 {\n\tpadding-top: 48px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: var(--primary-color);\n\tcolor: var(--white-color);\n\tfont-weight: bold;\n\tfont-size: 16px;\n\toutline: none !important;\n}\n\n.btnBlock {\n\twidth: 100%;\n\tposition: relative;\n\twhite-space: normal;\n\tdisplay: block;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:hover:focus {\n\tbackground: transparent;\n\tcolor: var(--primary-foreground);\n}\n\n.formControlSelect {\n\tmargin-bottom: 8px;\n}\n\n.splitList {\n\tdisplay: inline-block;\n\twidth: 50%;\n\tfont-size: 16px;\n\tpadding-right: 8px;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\twidth: 100%;\n}\n\n.displayTableCellIcon {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.textMutedNew {\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tvertical-align: middle;\n\tword-break: break-word;\n\tline-height: 26px;\n}\n\n.tableMarginTop {\n\tmargin-top: 16px;\n}\n\n.calendarTableCell {\n\tdisplay: inline-block;\n}\n\n.vrAlignTop {\n\tvertical-align: top;\n}\n\n.currenyMarginR {\n\tmargin-right: 6px;\n}\n\n.sectionLink {\n\tborder: 1px solid var(--secondary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n}\n\n.listingFontSize {\n\tfont-size: 16px !important;\n}\n\n.vrAlignBottom {\n\tvertical-align: bottom;\n}\n\n.introTextPadding {\n\tpadding-left: 8px;\n}\n\n.showHideBtn {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px !important;\n\tborder: 0px !important;\n\ttext-decoration: underline;\n}\n\n.showHideBtn.focus,\n.showHideBtn:focus,\n.showHideBtn:active,\n.showHideBtn:active:focus,\n.showHideBtn:focus,\n.showHideBtn:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: 16px;\n\tborder: 0px !important;\n}\n\n.showHideMargin {\n\tmargin-bottom: 10px !important;\n}\n\n.listingIntroWidth {\n\twidth: 65%;\n}\n\n.showHidePadding {\n\tpadding-bottom: 10px !important;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.listingLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.listingLineTwo {\n\tmargin: 15px 0 30px;\n}\n\n@media screen and (max-width: 767px) {\n\t.titleText {\n\t\tfont-weight: 700;\n\t\tfont-size: 26px;\n\t\tword-break: break-word;\n\t}\n\n\t.splitList {\n\t\tdisplay: inline-block;\n\t\twidth: 100% !important;\n\t}\n\n\t.listingIntroWidth {\n\t\twidth: 100% !important;\n\t}\n\n\t.responsiveListIngIntro {\n\t\tdisplay: inline-block !important;\n\t}\n}","@import '../common.css';\n\n.bannerContainer {\n\theight: 500px;\n\tposition: relative;\n\twidth: 100%;\n\ttransition: height .2s;\n\tcursor: pointer;\n\tborder-radius: 15px;\n}\n\n.bannerImage {\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n\tmin-height: 500px;\n}\n\n.viewPhotosBtn {\n\tbottom: 20px;\n\tright: 20px;\n\tposition: absolute;\n\tdisplay: inline-block;\n\tbackground: var(--background-primary) !important;\n\tcolor: var(--primary-foreground) !important;\n\tfont-size: 16px !important;\n\tfont-weight: bold !important;\n\tborder-radius: 8px !important;\n\tfont-weight: normal;\n\tcursor: pointer !important;\n\twidth: max-content;\n\tborder-color: transparent !important;\n}\n\n.bannerImage:hover {\n\tcursor: pointer;\n}\n\n.vtrBottom {\n\tvertical-align: bottom;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.saveButtonPosition {\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n}\n\n.displayInline {\n\tdisplay: inline-block;\n\tmargin-left: 25px;\n}\n\n.positionRelative {\n\tposition: relative;\n}\n\n@media screen and (max-height: 1200px) {\n\t.saveButtonPosition {\n\t\tright: 0px;\n\t}\n}\n\n@media screen and (min-height: 700px) {\n\n\t/* .bannerContainer {\n\t\theight: 552px;\n\t} */\n\t.leftBanner {\n\t\theight: 552px;\n\t}\n}\n\n@media screen and (min-height: 850px) {\n\n\t/* .bannerContainer {\n\t\theight: 545px;\n\t} */\n\t.leftBanner {\n\t\theight: 850px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContent": `Photos-pageContent-KLFfF`,
	"titleText": `Photos-titleText-Sp592`,
	"sectionTitleText": `Photos-sectionTitleText-Nzqjt`,
	"sectionTitleContent": `Photos-sectionTitleContent-p2mWT`,
	"sectionCaptionLink": `Photos-sectionCaptionLink-zldFy`,
	"textMuted": `Photos-textMuted-AIHu3`,
	"text": `Photos-text-cyyMI`,
	"textLine": `Photos-textLine-MAvh6`,
	"textCenter": `Photos-textCenter-V7V68`,
	"textError": `Photos-textError-yASZr`,
	"horizontalLineThrough": `Photos-horizontalLineThrough-T2NRr`,
	"space1": `Photos-space1-hqCU1`,
	"space2": `Photos-space2-HFGZk`,
	"space3": `Photos-space3-ReN5d`,
	"space4": `Photos-space4-Rrdtl`,
	"space5": `Photos-space5-Q_vEk`,
	"spaceTop1": `Photos-spaceTop1-T_ZEY`,
	"spaceTop2": `Photos-spaceTop2-PpwiX`,
	"spaceTop3": `Photos-spaceTop3-xNMB0`,
	"spaceTop4": `Photos-spaceTop4-UERTY`,
	"spaceTop5": `Photos-spaceTop5-FR1mh`,
	"padding1": `Photos-padding1-jvtJw`,
	"padding2": `Photos-padding2-H_WeB`,
	"padding3": `Photos-padding3-YSYNm`,
	"padding4": `Photos-padding4-kipCL`,
	"padding5": `Photos-padding5-ulE5u`,
	"paddingTop1": `Photos-paddingTop1-WdVxj`,
	"paddingTop2": `Photos-paddingTop2-rsxhE`,
	"paddingTop3": `Photos-paddingTop3-R5wAz`,
	"paddingTop4": `Photos-paddingTop4-RgWhL`,
	"paddingTop5": `Photos-paddingTop5-SUVMl`,
	"noMargin": `Photos-noMargin-ZIOOW`,
	"noPadding": `Photos-noPadding-youN1`,
	"noBorder": `Photos-noBorder-a2u6n`,
	"btn": `Photos-btn-HSSaM`,
	"btnBlock": `Photos-btnBlock-gtsQd`,
	"formControlSelect": `Photos-formControlSelect-HLoGf`,
	"splitList": `Photos-splitList-kr8R0`,
	"displayTable": `Photos-displayTable-Yhq1V`,
	"displayTableRow": `Photos-displayTableRow-SGJcq`,
	"displayTableCell": `Photos-displayTableCell-V53ua`,
	"displayTableCellIcon": `Photos-displayTableCellIcon-QI__b`,
	"textMutedNew": `Photos-textMutedNew-Gd6Ki`,
	"tableMarginTop": `Photos-tableMarginTop-UN_7w`,
	"calendarTableCell": `Photos-calendarTableCell-uaNnj`,
	"vrAlignTop": `Photos-vrAlignTop-x3ekh`,
	"currenyMarginR": `Photos-currenyMarginR-qWKgF`,
	"sectionLink": `Photos-sectionLink-agwzI`,
	"listingFontSize": `Photos-listingFontSize-MeHPE`,
	"vrAlignBottom": `Photos-vrAlignBottom-OeJ3F`,
	"introTextPadding": `Photos-introTextPadding-Zo9M5`,
	"showHideBtn": `Photos-showHideBtn-UnCR4`,
	"focus": `Photos-focus-h2kNH`,
	"showHideMargin": `Photos-showHideMargin-AmNGd`,
	"listingIntroWidth": `Photos-listingIntroWidth-Tryrb`,
	"showHidePadding": `Photos-showHidePadding-SWn5C`,
	"vtrTop": `Photos-vtrTop-A53SQ`,
	"listingLine": `Photos-listingLine-imeyR`,
	"listingLineTwo": `Photos-listingLineTwo-kr70W`,
	"responsiveListIngIntro": `Photos-responsiveListIngIntro-qHwlu`,
	"bannerContainer": `Photos-bannerContainer-V087T`,
	"bannerImage": `Photos-bannerImage-H4Sw8`,
	"viewPhotosBtn": `Photos-viewPhotosBtn-dOlNh`,
	"vtrBottom": `Photos-vtrBottom-kUXhT`,
	"vtrMiddle": `Photos-vtrMiddle-ee0zx`,
	"saveButtonPosition": `Photos-saveButtonPosition-sn0hY`,
	"displayInline": `Photos-displayInline-y7EPc`,
	"positionRelative": `Photos-positionRelative-m6JT0`,
	"leftBanner": `Photos-leftBanner-JxpJ8`
};
module.exports = ___CSS_LOADER_EXPORT___;
